






























import { defineComponent, ref } from "@vue/composition-api";
import { BButton, BCard, BListGroup, BListGroupItem } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
        BCard,
        BListGroup,
        BListGroupItem,
    },
    props: {
        list: {
            required: true,
            type: Object,
        },
    },
    setup() {
        const modalShow = ref(false);

        return {
            modalShow,
        };
    },
});
